<nz-skeleton
  [ngClass]="loading ? 'mt-4' : 'mt-0'"
  [nzLoading]="loading"
  [nzActive]="true"
>
  <div class="mt-4">
    <span><b>Shipping Information</b></span>
    <div
      class="p-3 mt-2 border rounded"
      style="border-color: grey !important;"
    >
      <div class="d-flex justify-content-between">
        <div class="d-flex justify-content-end">
          <img
            src="https://storage.googleapis.com/komerce/assets/icons/profile-placehold.svg"
            alt=""
            width="40px"
          />
          <div class="ml-4" style="margin-left: 15px">
            <span>
              <b>{{ detailOrder.receiver_name || "-" }}</b> <br />
              {{ detailOrder.receiver_phone || "-" }}
            </span>
          </div>
        </div>
        <div class="d-flex justify-content-end flex-column">
          <div class="d-flex align-items-end">
            <p>
              Shipping by
              <img
                src="https://storage.googleapis.com/komerce/assets/logo/Komship-by-komerce.svg"
                alt=""
                width="80px"
              />
            </p>
          </div>
          @if (detailOrder.shipping === 'LION') {
            <div class="d-flex">
              <button
                class="btn btn-outline-primary"
                (click)="onTrackReceipt()"
              >
                Track Receipt
              </button>
            </div>
          }
        </div>
      </div>
      <div class="d-flex mt-4 justify-content-between">
        <div class="col-6 text-secondary">
          <p>Expedition</p>
          <p>Tracking Number</p>
          <p>Address Detail</p>
          <p>Pinpoint</p>
        </div>
        <div class="col-6" style="font-weight: 600">
          <span>
            <img
              [src]="detailOrder.shipping_logo"
              [alt]="detailOrder.shipping"
              style="max-width: 100px"
            />
            <span class="mx-2">{{
              handleType(detailOrder.shipping_type)
            }}</span>
          </span>
          <p></p>
          <p>
            {{ detailOrder.awb || "-" }}
            <button class="btn p-0" (click)="onCopyAwb()">
              <img
                src="https://storage.googleapis.com/komerce/assets/copy.svg"
                alt="copy"
              />
            </button>
          </p>
          <p>{{ detailOrder.receiver_address || "-" }}</p>
          <div #mapContainer style="height: 200px; width: 100%;" class="rounded"></div>
          @if (detailOrder.shipping !== 'LION') {
            <p class="mt-4 d-flex justify-content-end">
              <button class="btn btn-outline-primary" (click)="onTrackPackage()">Track Receipt</button>
            </p>
          }
        </div>
      </div>
    </div>
  </div>
</nz-skeleton>
